import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["href", "modal"];
import { Button as Base } from "@cancer-council-queensland/react";
import { cleanHref } from "../lib";
import { Modal } from "./modal";
import { useCallback, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = _ref => {
  var {
    href,
    modal
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var [isModalOpen, setIsModalOpen] = useState(false);
  var openModel = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Base, _extends({
      openModel: modal ? openModel : undefined,
      href: cleanHref(href)
    }, rest)), modal && /*#__PURE__*/_jsx(Modal, _extends({}, modal.content, {
      isOpen: isModalOpen,
      setIsOpen: setIsModalOpen
    }))]
  });
};
//# sourceMappingURL=button.js.map